module.exports = __webpack_public_path__ + "static/media/IMG_0834.dc95910f.jpg";